import { CellRenderProps } from "@sinecycle/growcomponents";
import { TextColumn } from "./TextColumn";
import { TextColumnProps } from "./type";

interface TextCCellProps<T> extends CellRenderProps<T, string> {
  textColumnProps: Omit<TextColumnProps, "text">;
}
function TextCCell<T>(props: TextCCellProps<T>) {
  const { value, textColumnProps } = props;
  return <TextColumn {...textColumnProps} text={value} />;
}

export { TextCCell };
